import VxeRadioComponent from './src/radio';
import { dynamicApp } from '../dynamics';
export var VxeRadio = Object.assign(VxeRadioComponent, {
    install: function (app) {
        app.component(VxeRadioComponent.name, VxeRadioComponent);
    }
});
export var Radio = VxeRadio;
dynamicApp.component(VxeRadioComponent.name, VxeRadioComponent);
export default VxeRadio;
